import { gql } from '@apollo/client';

export const SEARCH_PEOPLE = gql`
  query getPeopleBySearchQuery($input: GetPeopleBySearchQueryInput!) {
    getPeopleBySearchQuery(input: $input) {
      _id
      affiliate
      crmId
      sfCrmId
      displayName
      email
      thumbnail
      title
      contractType
    }
  }
`;

export const GET_PEOPLE = gql`
  query masterDataPeople(
    $limit: Int
    $offset: Int
    $orderBy: [MasterDataPersonOrderByExp!]
    $where: MasterDataPersonBoolExp
  ) {
    masterDataPeople(limit: $limit, offset: $offset, order_by: $orderBy, where: $where) {
      _id
      affiliate
      crmId
      displayName
      email
      thumbnail
      title
      contractType
    }
  }
`;

export const GET_PERSON = gql`
  query masterDataPerson($_id: String!) {
    masterDataPerson(_id: $_id) {
      _id
      affiliate
      crmId
      displayName
      email
      thumbnail
      title
      contractType
    }
  }
`;

export const GET_USER = gql`
  query user($_id: String!) {
    user(_id: $_id) {
      _id
      name
      roles
      createdAt
      lastLoginAt
    }
  }
`;

export const GET_USERS = gql`
  query findUsersQuery($input: FindUsersQueryInput!) {
    result: findUsersQuery(input: $input) {
      data {
        _id
        name
        roles
        createdAt
        lastLoginAt
      }
      pagination {
        currentPage
        itemsPerPage
        totalPages
        totalItems
      }
    }
  }
`;
